// extracted by mini-css-extract-plugin
export var label = "_s6-0";
export var link = "_s6-1";